import React from "react";
import styled from "styled-components";

export default styled.input`
    width: 636px;
    height: 50px;
    border: 1px solid #979797;
    padding: 10px;
`;